import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { ExternalPropertyPatch } from 'crono-fe-common/types/DTO/externalPropertyPatch';

export default function usePatchExternalProperty() {
  const queryClient = useQueryClient();

  const patchExternalPropertyOption = (data: ExternalPropertyPatch) => {
    const request: Request = {
      url: ENDPOINTS.externalProperty.main,
      config: {
        method: 'patch',
        data: data,
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    ExternalPropertyPatch
  >(patchExternalPropertyOption, {
    onSettled: () => {
      queryClient.invalidateQueries([ENDPOINTS.externalProperty.main]);
      queryClient.invalidateQueries([ENDPOINTS.externalProperty.status.main]);
    },
  });

  return { data, mutate, ...rest };
}
